// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sfm-layout {
    display: grid;
    align-items: start;
    grid-template-columns: 180px minmax(0, 1fr);
    gap: 0;
}

.sfm-manager-header {
    align-items: flex-start;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    margin-bottom: 24px;
}

.sfm-manager-header h1 {
    font-size: 1.5rem;
    margin: 0 0 4px;
}

.sfm-manager-header p {
    margin: 0;
}

.sfm-nav {
    align-self: start;
    border-right: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 12px;
}

.sfm-nav-item {
    appearance: none;
    background: transparent;
    border: 0;
    border-left: 3px solid transparent;
    color: inherit;
    cursor: pointer;
    display: block;
    font: inherit;
    padding: 10px 16px;
    text-align: left;
}

.sfm-nav-item:hover {
    background: rgba(49, 108, 41, 0.08);
}

.sfm-nav-item.active {
    border-left-color: #316C29;
    font-weight: 600;
}

.sfm-panel {
    min-width: 0;
    padding: 0 0 0 32px;
}

.sfm-manager-footer {
    border-top: 1px solid #eee;
    margin-top: 32px;
    padding-top: 16px;
}

.sfm-manager-footer .checkbox {
    margin: 0;
}

.sfm-preview-modal.modal--fullscreen {
    border-radius: 8px;
    height: min(860px, calc(100vh - 48px));
    max-height: calc(100vh - 48px);
    max-width: calc(100vw - 48px);
    width: min(1120px, calc(100vw - 48px));
}

.sfm-preview-modal .modal__content {
    overflow: hidden;
    padding: 16px;
}

.sfm-preview-modal .modal__footer {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: flex-end;
}

.sfm-preview-description {
    margin: 0 0 12px;
}

.sfm-preview-saved-message {
    background: #eef7f0;
    border: 1px solid #c9e6d0;
    border-radius: 6px;
    color: #2e7d46;
    font-size: 0.9rem;
    margin: 0 0 12px;
    padding: 8px 10px;
}

.sfm-preview-frame-shell {
    background: #f7f7f7;
    border: 1px solid #ddd;
    border-radius: 6px;
    height: min(650px, calc(100vh - 220px));
    overflow: hidden;
    width: 100%;
}

.sfm-preview-frame {
    background: #fff;
    border: 0;
    display: block;
    height: 100%;
    width: 100%;
}

.sfm-preview-empty {
    border: 1px dashed #ccc;
    border-radius: 6px;
    padding: 16px;
}

.sfm-section-header {
    margin-bottom: 20px;
}

.sfm-section-header h2 {
    margin-bottom: 6px;
}

.sfm-section-header p {
    margin: 0;
}

.sfm-save-row {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 20px;
}

.sfm-feedback {
    font-weight: 600;
}

.sfm-feedback-success {
    color: #2e7d46;
}

.sfm-feedback-error {
    color: #b71c1c;
}

.sfm-color-pair {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
.sfm-color-pair .group {
    margin-bottom: 0;
}
.sfm-color-pair + .help {
    margin-bottom: 1rem !important;
}

.sfm-color-presets {
    border: 0;
    margin: 0 0 24px;
    padding: 0;
}

.sfm-color-presets legend {
    font-weight: 600;
    padding: 0;
}

.sfm-color-presets > .help {
    margin: 4px 0 10px;
}

.sfm-color-preset-grid {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
}

.sfm-color-preset {
    appearance: none;
    background: transparent;
    border: 1px solid #ccc;
    border-radius: 7px;
    color: inherit;
    cursor: pointer;
    font: inherit;
    font-size: 0.85rem;
    font-weight: 600;
    overflow: hidden;
    padding: 0 0 7px;
    text-align: left;
}

.sfm-color-preset:hover,
.sfm-color-preset:focus-visible {
    border-color: #316C29;
}

.sfm-color-preset.selected {
    border-color: #316C29;
    box-shadow: 0 0 0 2px rgba(49, 108, 41, 0.2);
}

.sfm-color-preset > span:last-child {
    display: block;
    padding: 7px 8px 0;
}

.sfm-color-preset-swatches {
    display: grid;
    grid-template-columns: repeat(3, 1fr) 8px;
    height: 42px;
}

.sfm-color-preset-swatches > span {
    align-items: center;
    display: flex;
    font-size: 0.7rem;
    justify-content: center;
}

.sfm-segmented-field {
    border: 0;
    margin: 0 0 24px;
    padding: 0;
}

.sfm-segmented-field legend {
    font-weight: 600;
    padding: 0;
}

.sfm-segmented-field > .help {
    margin: 4px 0 10px;
}

.sfm-segmented {
    display: inline-flex;
    border: 1px solid #ccc;
    border-radius: 7px;
    overflow: hidden;
}

.sfm-segmented-option {
    appearance: none;
    background: transparent;
    border: none;
    border-right: 1px solid #ccc;
    color: inherit;
    cursor: pointer;
    font: inherit;
    font-size: 0.85rem;
    font-weight: 600;
    padding: 8px 16px;
}

.sfm-segmented-option:last-child {
    border-right: none;
}

.sfm-segmented-option:hover,
.sfm-segmented-option:focus-visible {
    background: rgba(49, 108, 41, 0.08);
}

.sfm-segmented-option.selected {
    background: #316C29;
    color: #fff;
}

.sfm-template-presets {
    border: 0;
    margin: 0 0 24px;
    padding: 0;
}

.sfm-template-presets legend {
    font-weight: 600;
    padding: 0;
}

.sfm-template-presets > .help {
    margin: 4px 0 10px;
}

.sfm-template-preset-grid {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

.sfm-template-preset {
    appearance: none;
    background: transparent;
    border: 1px solid #ccc;
    border-radius: 7px;
    color: inherit;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font: inherit;
    gap: 4px;
    padding: 10px 12px;
    text-align: left;
}

.sfm-template-preset:hover,
.sfm-template-preset:focus-visible {
    border-color: #316C29;
}

.sfm-template-preset.selected {
    border-color: #316C29;
    box-shadow: 0 0 0 2px rgba(49, 108, 41, 0.2);
}

.sfm-template-preset-label {
    font-size: 0.9rem;
    font-weight: 600;
}

.sfm-template-preset-description {
    color: #666;
    font-size: 0.78rem;
}

.sfm-branding-preview {
    border: 1px solid #ccc;
    border-radius: 8px;
    margin-bottom: 24px;
    overflow: hidden;
}

.sfm-branding-preview-heading {
    align-items: center;
    background: #f7f7f7;
    color: #222;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 10px 12px;
}

.sfm-branding-preview-heading h3 {
    color: inherit;
    font-size: 0.95rem;
    margin: 0 0 2px;
}

.sfm-branding-preview-heading p {
    font-size: 0.75rem;
    margin: 0;
}

.sfm-branding-preview-heading > span {
    background: #e7e7e7;
    border-radius: 999px;
    flex: 0 0 auto;
    font-size: 0.7rem;
    padding: 3px 8px;
}

.sfm-branding-preview-body {
    display: grid;
    grid-template-columns: minmax(130px, 0.6fr) minmax(0, 2.4fr);
    min-height: 230px;
}

div.page .sfm-branding-preview-sidebar {
    align-items: stretch;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 0;
    justify-content: flex-start;
    padding: 0;
}

.sfm-branding-preview-sidebar strong {
    display: block;
    font-size: 1rem;
    margin: 0;
    padding: 18px 14px 16px;
    text-align: center;
}

.sfm-branding-preview-sidebar span {
    display: block;
    font-size: 0.76rem;
    line-height: 1.2;
    padding: 8px 16px;
}

.sfm-branding-preview-sidebar span:first-of-type {
    margin-top: 6px;
}

.sfm-branding-preview-content {
    padding: 20px;
}

.sfm-branding-preview-kicker {
    font-size: 0.68rem;
    letter-spacing: 0.08em;
    margin: 0;
    text-transform: uppercase;
}

.sfm-branding-preview-content h4 {
    color: inherit;
    font-size: 1.25rem;
    margin: 2px 0 14px;
}

.sfm-branding-preview-cards {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.sfm-branding-preview-cards article {
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    font-size: 0.67rem;
    gap: 4px;
    min-width: 0;
    padding: 8px;
}

.sfm-branding-preview-cards article strong {
    font-size: 0.76rem;
}

.sfm-branding-preview-product {
    background: rgba(127, 127, 127, 0.2);
    border-radius: 3px;
    display: block;
    height: 42px;
}

.sfm-branding-preview-content > button {
    border: 0;
    border-radius: 4px;
    color: #fff;
    font: inherit;
    font-size: 0.72rem;
    font-weight: 600;
    margin-top: 12px;
    padding: 6px 12px;
    pointer-events: none;
}

.sfm-warning {
    background: #fff4e5;
    border: 1px solid #f0c36d;
    border-radius: 6px;
    margin-bottom: 20px;
    padding: 12px 14px;
}

.sfm-warning ul {
    margin: 8px 0 0 18px;
}

.sfm-imagery-preview {
    border: 1px solid #ddd;
    border-radius: 6px;
    display: block;
    margin-bottom: 10px;
    max-height: 140px;
    max-width: 180px;
}

.sfm-imagery-group + .sfm-imagery-group {
    border-top: 1px solid #ddd;
    padding-top: 20px;
}

.sfm-current-image > p {
    font-weight: 600;
    margin-bottom: 8px;
}

.sfm-crop-preview {
    margin: 0;
    min-width: 0;
}

.sfm-crop-preview figcaption {
    color: #555;
    font-size: 0.8rem;
    margin-top: 6px;
}

.sfm-banner-crop-previews {
    display: grid;
    gap: 12px 16px;
    grid-template-columns: minmax(0, 3fr) minmax(140px, 1fr);
    margin-bottom: 12px;
    max-width: 760px;
}

.sfm-banner-crop-frame {
    background: #1D2E23;
    border: 1px solid #bbb;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    width: 100%;
}

.sfm-banner-crop-frame--desktop {
    aspect-ratio: 3 / 1;
}

.sfm-banner-crop-frame--mobile {
    aspect-ratio: 2 / 1;
}

.sfm-banner-crop-image,
.sfm-banner-crop-backdrop {
    display: block;
    height: 100%;
    object-fit: cover;
    object-position: center;
    width: 100%;
}

.sfm-banner-crop-image {
    position: relative;
    z-index: 1;
}

.sfm-banner-crop-backdrop {
    filter: blur(16px) brightness(0.55) saturate(0.85);
    inset: 0;
    position: absolute;
    transform: scale(1.12);
}

.sfm-banner-crop-frame--contained .sfm-banner-crop-image {
    object-fit: contain;
}

.sfm-contained-banner-note {
    grid-column: 1 / -1;
    margin: 0 !important;
}

.sfm-profile-crop-preview {
    margin-bottom: 12px;
    width: fit-content;
}

.sfm-profile-crop-frame {
    background: #263934;
    border: 4px solid rgba(255, 255, 255, 0.92);
    border-radius: 50%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.32);
    height: 144px;
    overflow: hidden;
    width: 144px;
}

.sfm-profile-crop-frame img {
    display: block;
    height: 100%;
    object-fit: cover;
    object-position: center;
    width: 100%;
}

.sfm-language-settings {
    border: 1px solid #ddd;
    border-radius: 6px;
    margin-top: 20px;
    padding: 16px;
}

.sfm-language-settings legend {
    font-weight: 600;
    padding: 0 6px;
}

.sfm-language-settings > .help {
    margin-top: 0;
}

.sfm-language-options {
    display: grid;
    gap: 10px 16px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-height: 300px;
    overflow-y: auto;
}

.sfm-language-options .checkbox {
    margin: 0;
}

.sfm-current-location {
    border: 1px solid #ddd;
    border-radius: 6px;
    margin-top: 16px;
    padding: 12px;
}

.sfm-slug-status-available {
    color: #2e7d46;
}

.sfm-slug-status-checking {
    color: #555;
}

.sfm-slug-status-taken,
.sfm-slug-status-error {
    color: #b71c1c;
}

.link-button {
    background: none;
    border: 0;
    color: #316C29;
    cursor: pointer;
    font: inherit;
    padding: 0;
    text-decoration: underline;
}

@media (max-width: 640px) {
    .sfm-manager-header {
        display: block;
    }

    .sfm-manager-header .button {
        margin-top: 12px;
    }

    .sfm-layout {
        display: block;
    }

    .sfm-nav {
        border-bottom: 1px solid #ddd;
        border-right: none;
        flex-direction: row;
        overflow-x: auto;
        position: static;
        white-space: nowrap;
    }

    .sfm-nav-item {
        border-bottom: 3px solid transparent;
        border-left: none;
        flex: 0 0 auto;
    }

    .sfm-nav-item.active {
        border-bottom-color: #316C29;
        border-left: none;
    }

    .sfm-panel {
        padding: 16px 0 0;
    }

    .sfm-language-options {
        grid-template-columns: 1fr;
    }

    .sfm-preview-modal.modal--fullscreen {
        border-radius: 0;
        height: 100%;
        max-height: 100%;
        max-width: 100%;
        width: 100%;
    }

    .sfm-preview-modal .modal__content {
        padding: 12px;
    }

    .sfm-preview-modal .modal__footer {
        gap: 8px;
        padding: 12px;
    }

    .sfm-preview-modal .modal__footer .button {
        flex: 1 1 145px;
        justify-content: center;
        text-align: center;
    }

    .sfm-preview-description {
        margin-bottom: 8px;
    }

    .sfm-preview-frame-shell {
        height: calc(100vh - 190px);
    }

    .sfm-preview-frame {
        height: 100%;
        width: 100%;
    }

    .sfm-color-pair {
        grid-template-columns: 1fr;
    }

    .sfm-branding-preview-body {
        grid-template-columns: 112px minmax(0, 1fr);
    }

    .sfm-branding-preview-content {
        padding: 14px;
    }

    .sfm-banner-crop-previews {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 480px) {
    .sfm-preview-modal .modal__footer .button {
        flex-basis: 100%;
    }
}
[data-theme="dark"] .sfm-nav { border-right-color: #2c3a33; }
[data-theme="dark"] .sfm-manager-footer { border-top-color: #2c3a33; }
[data-theme="dark"] .sfm-preview-saved-message { background: #16301f; border-color: #2c5c3b; color: #8fd6a0; }
[data-theme="dark"] .sfm-preview-frame-shell { background: #222f28; border-color: #3a463e; }
[data-theme="dark"] .sfm-preview-empty { border-color: #3a463e; }
[data-theme="dark"] .sfm-warning { background: #3a2c10; border-color: #6b4e1a; }
[data-theme="dark"] .sfm-color-preset { border-color: #3a463e; }
[data-theme="dark"] .sfm-color-preset:hover,
[data-theme="dark"] .sfm-color-preset:focus-visible,
[data-theme="dark"] .sfm-color-preset.selected { border-color: #71a36b; }
[data-theme="dark"] .sfm-branding-preview { border-color: #3a463e; }
[data-theme="dark"] .sfm-current-location { border-color: #2c3a33; }
[data-theme="dark"] .sfm-slug-status-checking { color: #9fb0a6; }
[data-theme="dark"] .sfm-imagery-preview,
[data-theme="dark"] .sfm-banner-crop-frame { border-color: #3a463e; }
[data-theme="dark"] .sfm-crop-preview figcaption { color: #aab8af; }
@media (max-width: 640px) {
    [data-theme="dark"] .sfm-nav { border-bottom-color: #2c3a33; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Storefront/StorefrontManager.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,2CAA2C;IAC3C,MAAM;AACV;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,8BAA8B;IAC9B,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gDAAgD;AACpD;AACA;IACI,gBAAgB;AACpB;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2DAA2D;AAC/D;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2DAA2D;AAC/D;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,wDAAwD;IACxD,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kDAAkD;IAClD,QAAQ;IACR,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gDAAgD;IAChD,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;IACf,aAAa;IACb,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oCAAoC;QACpC,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA,+BAA+B,2BAA2B,EAAE;AAC5D,0CAA0C,yBAAyB,EAAE;AACrE,iDAAiD,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC7G,+CAA+C,mBAAmB,EAAE,qBAAqB,EAAE;AAC3F,yCAAyC,qBAAqB,EAAE;AAChE,mCAAmC,mBAAmB,EAAE,qBAAqB,EAAE;AAC/E,wCAAwC,qBAAqB,EAAE;AAC/D;;iDAEiD,qBAAqB,EAAE;AACxE,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;AACnE,gDAAgD,cAAc,EAAE;AAChE;6CAC6C,qBAAqB,EAAE;AACpE,mDAAmD,cAAc,EAAE;AACnE;IACI,+BAA+B,4BAA4B,EAAE;AACjE","sourcesContent":[".sfm-layout {\n    display: grid;\n    align-items: start;\n    grid-template-columns: 180px minmax(0, 1fr);\n    gap: 0;\n}\n\n.sfm-manager-header {\n    align-items: flex-start;\n    display: flex;\n    gap: 16px;\n    justify-content: space-between;\n    margin-bottom: 24px;\n}\n\n.sfm-manager-header h1 {\n    font-size: 1.5rem;\n    margin: 0 0 4px;\n}\n\n.sfm-manager-header p {\n    margin: 0;\n}\n\n.sfm-nav {\n    align-self: start;\n    border-right: 1px solid #ddd;\n    display: flex;\n    flex-direction: column;\n    position: sticky;\n    top: 12px;\n}\n\n.sfm-nav-item {\n    appearance: none;\n    background: transparent;\n    border: 0;\n    border-left: 3px solid transparent;\n    color: inherit;\n    cursor: pointer;\n    display: block;\n    font: inherit;\n    padding: 10px 16px;\n    text-align: left;\n}\n\n.sfm-nav-item:hover {\n    background: rgba(49, 108, 41, 0.08);\n}\n\n.sfm-nav-item.active {\n    border-left-color: #316C29;\n    font-weight: 600;\n}\n\n.sfm-panel {\n    min-width: 0;\n    padding: 0 0 0 32px;\n}\n\n.sfm-manager-footer {\n    border-top: 1px solid #eee;\n    margin-top: 32px;\n    padding-top: 16px;\n}\n\n.sfm-manager-footer .checkbox {\n    margin: 0;\n}\n\n.sfm-preview-modal.modal--fullscreen {\n    border-radius: 8px;\n    height: min(860px, calc(100vh - 48px));\n    max-height: calc(100vh - 48px);\n    max-width: calc(100vw - 48px);\n    width: min(1120px, calc(100vw - 48px));\n}\n\n.sfm-preview-modal .modal__content {\n    overflow: hidden;\n    padding: 16px;\n}\n\n.sfm-preview-modal .modal__footer {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    justify-content: flex-end;\n}\n\n.sfm-preview-description {\n    margin: 0 0 12px;\n}\n\n.sfm-preview-saved-message {\n    background: #eef7f0;\n    border: 1px solid #c9e6d0;\n    border-radius: 6px;\n    color: #2e7d46;\n    font-size: 0.9rem;\n    margin: 0 0 12px;\n    padding: 8px 10px;\n}\n\n.sfm-preview-frame-shell {\n    background: #f7f7f7;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    height: min(650px, calc(100vh - 220px));\n    overflow: hidden;\n    width: 100%;\n}\n\n.sfm-preview-frame {\n    background: #fff;\n    border: 0;\n    display: block;\n    height: 100%;\n    width: 100%;\n}\n\n.sfm-preview-empty {\n    border: 1px dashed #ccc;\n    border-radius: 6px;\n    padding: 16px;\n}\n\n.sfm-section-header {\n    margin-bottom: 20px;\n}\n\n.sfm-section-header h2 {\n    margin-bottom: 6px;\n}\n\n.sfm-section-header p {\n    margin: 0;\n}\n\n.sfm-save-row {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-top: 20px;\n}\n\n.sfm-feedback {\n    font-weight: 600;\n}\n\n.sfm-feedback-success {\n    color: #2e7d46;\n}\n\n.sfm-feedback-error {\n    color: #b71c1c;\n}\n\n.sfm-color-pair {\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.sfm-color-pair .group {\n    margin-bottom: 0;\n}\n.sfm-color-pair + .help {\n    margin-bottom: 1rem !important;\n}\n\n.sfm-color-presets {\n    border: 0;\n    margin: 0 0 24px;\n    padding: 0;\n}\n\n.sfm-color-presets legend {\n    font-weight: 600;\n    padding: 0;\n}\n\n.sfm-color-presets > .help {\n    margin: 4px 0 10px;\n}\n\n.sfm-color-preset-grid {\n    display: grid;\n    gap: 10px;\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n}\n\n.sfm-color-preset {\n    appearance: none;\n    background: transparent;\n    border: 1px solid #ccc;\n    border-radius: 7px;\n    color: inherit;\n    cursor: pointer;\n    font: inherit;\n    font-size: 0.85rem;\n    font-weight: 600;\n    overflow: hidden;\n    padding: 0 0 7px;\n    text-align: left;\n}\n\n.sfm-color-preset:hover,\n.sfm-color-preset:focus-visible {\n    border-color: #316C29;\n}\n\n.sfm-color-preset.selected {\n    border-color: #316C29;\n    box-shadow: 0 0 0 2px rgba(49, 108, 41, 0.2);\n}\n\n.sfm-color-preset > span:last-child {\n    display: block;\n    padding: 7px 8px 0;\n}\n\n.sfm-color-preset-swatches {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr) 8px;\n    height: 42px;\n}\n\n.sfm-color-preset-swatches > span {\n    align-items: center;\n    display: flex;\n    font-size: 0.7rem;\n    justify-content: center;\n}\n\n.sfm-segmented-field {\n    border: 0;\n    margin: 0 0 24px;\n    padding: 0;\n}\n\n.sfm-segmented-field legend {\n    font-weight: 600;\n    padding: 0;\n}\n\n.sfm-segmented-field > .help {\n    margin: 4px 0 10px;\n}\n\n.sfm-segmented {\n    display: inline-flex;\n    border: 1px solid #ccc;\n    border-radius: 7px;\n    overflow: hidden;\n}\n\n.sfm-segmented-option {\n    appearance: none;\n    background: transparent;\n    border: none;\n    border-right: 1px solid #ccc;\n    color: inherit;\n    cursor: pointer;\n    font: inherit;\n    font-size: 0.85rem;\n    font-weight: 600;\n    padding: 8px 16px;\n}\n\n.sfm-segmented-option:last-child {\n    border-right: none;\n}\n\n.sfm-segmented-option:hover,\n.sfm-segmented-option:focus-visible {\n    background: rgba(49, 108, 41, 0.08);\n}\n\n.sfm-segmented-option.selected {\n    background: #316C29;\n    color: #fff;\n}\n\n.sfm-template-presets {\n    border: 0;\n    margin: 0 0 24px;\n    padding: 0;\n}\n\n.sfm-template-presets legend {\n    font-weight: 600;\n    padding: 0;\n}\n\n.sfm-template-presets > .help {\n    margin: 4px 0 10px;\n}\n\n.sfm-template-preset-grid {\n    display: grid;\n    gap: 10px;\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n}\n\n.sfm-template-preset {\n    appearance: none;\n    background: transparent;\n    border: 1px solid #ccc;\n    border-radius: 7px;\n    color: inherit;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    font: inherit;\n    gap: 4px;\n    padding: 10px 12px;\n    text-align: left;\n}\n\n.sfm-template-preset:hover,\n.sfm-template-preset:focus-visible {\n    border-color: #316C29;\n}\n\n.sfm-template-preset.selected {\n    border-color: #316C29;\n    box-shadow: 0 0 0 2px rgba(49, 108, 41, 0.2);\n}\n\n.sfm-template-preset-label {\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n.sfm-template-preset-description {\n    color: #666;\n    font-size: 0.78rem;\n}\n\n.sfm-branding-preview {\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    margin-bottom: 24px;\n    overflow: hidden;\n}\n\n.sfm-branding-preview-heading {\n    align-items: center;\n    background: #f7f7f7;\n    color: #222;\n    display: flex;\n    gap: 12px;\n    justify-content: space-between;\n    padding: 10px 12px;\n}\n\n.sfm-branding-preview-heading h3 {\n    color: inherit;\n    font-size: 0.95rem;\n    margin: 0 0 2px;\n}\n\n.sfm-branding-preview-heading p {\n    font-size: 0.75rem;\n    margin: 0;\n}\n\n.sfm-branding-preview-heading > span {\n    background: #e7e7e7;\n    border-radius: 999px;\n    flex: 0 0 auto;\n    font-size: 0.7rem;\n    padding: 3px 8px;\n}\n\n.sfm-branding-preview-body {\n    display: grid;\n    grid-template-columns: minmax(130px, 0.6fr) minmax(0, 2.4fr);\n    min-height: 230px;\n}\n\ndiv.page .sfm-branding-preview-sidebar {\n    align-items: stretch;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    justify-content: flex-start;\n    padding: 0;\n}\n\n.sfm-branding-preview-sidebar strong {\n    display: block;\n    font-size: 1rem;\n    margin: 0;\n    padding: 18px 14px 16px;\n    text-align: center;\n}\n\n.sfm-branding-preview-sidebar span {\n    display: block;\n    font-size: 0.76rem;\n    line-height: 1.2;\n    padding: 8px 16px;\n}\n\n.sfm-branding-preview-sidebar span:first-of-type {\n    margin-top: 6px;\n}\n\n.sfm-branding-preview-content {\n    padding: 20px;\n}\n\n.sfm-branding-preview-kicker {\n    font-size: 0.68rem;\n    letter-spacing: 0.08em;\n    margin: 0;\n    text-transform: uppercase;\n}\n\n.sfm-branding-preview-content h4 {\n    color: inherit;\n    font-size: 1.25rem;\n    margin: 2px 0 14px;\n}\n\n.sfm-branding-preview-cards {\n    display: grid;\n    gap: 10px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.sfm-branding-preview-cards article {\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    font-size: 0.67rem;\n    gap: 4px;\n    min-width: 0;\n    padding: 8px;\n}\n\n.sfm-branding-preview-cards article strong {\n    font-size: 0.76rem;\n}\n\n.sfm-branding-preview-product {\n    background: rgba(127, 127, 127, 0.2);\n    border-radius: 3px;\n    display: block;\n    height: 42px;\n}\n\n.sfm-branding-preview-content > button {\n    border: 0;\n    border-radius: 4px;\n    color: #fff;\n    font: inherit;\n    font-size: 0.72rem;\n    font-weight: 600;\n    margin-top: 12px;\n    padding: 6px 12px;\n    pointer-events: none;\n}\n\n.sfm-warning {\n    background: #fff4e5;\n    border: 1px solid #f0c36d;\n    border-radius: 6px;\n    margin-bottom: 20px;\n    padding: 12px 14px;\n}\n\n.sfm-warning ul {\n    margin: 8px 0 0 18px;\n}\n\n.sfm-imagery-preview {\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    display: block;\n    margin-bottom: 10px;\n    max-height: 140px;\n    max-width: 180px;\n}\n\n.sfm-imagery-group + .sfm-imagery-group {\n    border-top: 1px solid #ddd;\n    padding-top: 20px;\n}\n\n.sfm-current-image > p {\n    font-weight: 600;\n    margin-bottom: 8px;\n}\n\n.sfm-crop-preview {\n    margin: 0;\n    min-width: 0;\n}\n\n.sfm-crop-preview figcaption {\n    color: #555;\n    font-size: 0.8rem;\n    margin-top: 6px;\n}\n\n.sfm-banner-crop-previews {\n    display: grid;\n    gap: 12px 16px;\n    grid-template-columns: minmax(0, 3fr) minmax(140px, 1fr);\n    margin-bottom: 12px;\n    max-width: 760px;\n}\n\n.sfm-banner-crop-frame {\n    background: #1D2E23;\n    border: 1px solid #bbb;\n    border-radius: 6px;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n}\n\n.sfm-banner-crop-frame--desktop {\n    aspect-ratio: 3 / 1;\n}\n\n.sfm-banner-crop-frame--mobile {\n    aspect-ratio: 2 / 1;\n}\n\n.sfm-banner-crop-image,\n.sfm-banner-crop-backdrop {\n    display: block;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    width: 100%;\n}\n\n.sfm-banner-crop-image {\n    position: relative;\n    z-index: 1;\n}\n\n.sfm-banner-crop-backdrop {\n    filter: blur(16px) brightness(0.55) saturate(0.85);\n    inset: 0;\n    position: absolute;\n    transform: scale(1.12);\n}\n\n.sfm-banner-crop-frame--contained .sfm-banner-crop-image {\n    object-fit: contain;\n}\n\n.sfm-contained-banner-note {\n    grid-column: 1 / -1;\n    margin: 0 !important;\n}\n\n.sfm-profile-crop-preview {\n    margin-bottom: 12px;\n    width: fit-content;\n}\n\n.sfm-profile-crop-frame {\n    background: #263934;\n    border: 4px solid rgba(255, 255, 255, 0.92);\n    border-radius: 50%;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.32);\n    height: 144px;\n    overflow: hidden;\n    width: 144px;\n}\n\n.sfm-profile-crop-frame img {\n    display: block;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    width: 100%;\n}\n\n.sfm-language-settings {\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    margin-top: 20px;\n    padding: 16px;\n}\n\n.sfm-language-settings legend {\n    font-weight: 600;\n    padding: 0 6px;\n}\n\n.sfm-language-settings > .help {\n    margin-top: 0;\n}\n\n.sfm-language-options {\n    display: grid;\n    gap: 10px 16px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.sfm-language-options .checkbox {\n    margin: 0;\n}\n\n.sfm-current-location {\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    margin-top: 16px;\n    padding: 12px;\n}\n\n.sfm-slug-status-available {\n    color: #2e7d46;\n}\n\n.sfm-slug-status-checking {\n    color: #555;\n}\n\n.sfm-slug-status-taken,\n.sfm-slug-status-error {\n    color: #b71c1c;\n}\n\n.link-button {\n    background: none;\n    border: 0;\n    color: #316C29;\n    cursor: pointer;\n    font: inherit;\n    padding: 0;\n    text-decoration: underline;\n}\n\n@media (max-width: 640px) {\n    .sfm-manager-header {\n        display: block;\n    }\n\n    .sfm-manager-header .button {\n        margin-top: 12px;\n    }\n\n    .sfm-layout {\n        display: block;\n    }\n\n    .sfm-nav {\n        border-bottom: 1px solid #ddd;\n        border-right: none;\n        flex-direction: row;\n        overflow-x: auto;\n        position: static;\n        white-space: nowrap;\n    }\n\n    .sfm-nav-item {\n        border-bottom: 3px solid transparent;\n        border-left: none;\n        flex: 0 0 auto;\n    }\n\n    .sfm-nav-item.active {\n        border-bottom-color: #316C29;\n        border-left: none;\n    }\n\n    .sfm-panel {\n        padding: 16px 0 0;\n    }\n\n    .sfm-language-options {\n        grid-template-columns: 1fr;\n    }\n\n    .sfm-preview-modal.modal--fullscreen {\n        border-radius: 0;\n        height: 100%;\n        max-height: 100%;\n        max-width: 100%;\n        width: 100%;\n    }\n\n    .sfm-preview-modal .modal__content {\n        padding: 12px;\n    }\n\n    .sfm-preview-modal .modal__footer {\n        gap: 8px;\n        padding: 12px;\n    }\n\n    .sfm-preview-modal .modal__footer .button {\n        flex: 1 1 145px;\n        justify-content: center;\n        text-align: center;\n    }\n\n    .sfm-preview-description {\n        margin-bottom: 8px;\n    }\n\n    .sfm-preview-frame-shell {\n        height: calc(100vh - 190px);\n    }\n\n    .sfm-preview-frame {\n        height: 100%;\n        width: 100%;\n    }\n\n    .sfm-color-pair {\n        grid-template-columns: 1fr;\n    }\n\n    .sfm-branding-preview-body {\n        grid-template-columns: 112px minmax(0, 1fr);\n    }\n\n    .sfm-branding-preview-content {\n        padding: 14px;\n    }\n\n    .sfm-banner-crop-previews {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 480px) {\n    .sfm-preview-modal .modal__footer .button {\n        flex-basis: 100%;\n    }\n}\n[data-theme=\"dark\"] .sfm-nav { border-right-color: #2c3a33; }\n[data-theme=\"dark\"] .sfm-manager-footer { border-top-color: #2c3a33; }\n[data-theme=\"dark\"] .sfm-preview-saved-message { background: #16301f; border-color: #2c5c3b; color: #8fd6a0; }\n[data-theme=\"dark\"] .sfm-preview-frame-shell { background: #222f28; border-color: #3a463e; }\n[data-theme=\"dark\"] .sfm-preview-empty { border-color: #3a463e; }\n[data-theme=\"dark\"] .sfm-warning { background: #3a2c10; border-color: #6b4e1a; }\n[data-theme=\"dark\"] .sfm-color-preset { border-color: #3a463e; }\n[data-theme=\"dark\"] .sfm-color-preset:hover,\n[data-theme=\"dark\"] .sfm-color-preset:focus-visible,\n[data-theme=\"dark\"] .sfm-color-preset.selected { border-color: #71a36b; }\n[data-theme=\"dark\"] .sfm-branding-preview { border-color: #3a463e; }\n[data-theme=\"dark\"] .sfm-current-location { border-color: #2c3a33; }\n[data-theme=\"dark\"] .sfm-slug-status-checking { color: #9fb0a6; }\n[data-theme=\"dark\"] .sfm-imagery-preview,\n[data-theme=\"dark\"] .sfm-banner-crop-frame { border-color: #3a463e; }\n[data-theme=\"dark\"] .sfm-crop-preview figcaption { color: #aab8af; }\n@media (max-width: 640px) {\n    [data-theme=\"dark\"] .sfm-nav { border-bottom-color: #2c3a33; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
